import { handleActions, createAction } from 'redux-actions';
import { api } from '../../../services';
import { UserRole } from '../../../models';

const ADMIN_GET = 'ADMIN_GET';
const ADMIN_CHANGE_PAGE = 'ADMIN_CHANGE_PAGE';
const ADMIN_CREATE = 'ADMIN_CHANGE_PAGE';
const ADMIN_ACTIVE = 'ADMIN_ACTIVE';
const ADMIN_INACTIVE = 'ADMIN_INACTIVE';

// Actions
export const getAdminUsers = createAction(ADMIN_GET, async (page, itemPerPage, callback) => {
  try {
    const data = await api.User.list({
      page,
      limit: itemPerPage,
      roles: [UserRole.admin, UserRole.superAdmin],
      format: 3,
    });

    callback && callback()
    return { admins: data.data, total: data.count };
  } catch (error) {
    return null;
  }
});

export const changePage = createAction(ADMIN_CHANGE_PAGE, page => ({ page }));

export const createAdmin = createAction(
  ADMIN_CREATE,
  async (data, callback) => {
    try {
      await api.User.createAdmin(data);

      callback && callback(true);

      return null;
    } catch (error) {
      callback && callback(false);

      return null;
    }
  }
);

export const blockAdmin = createAction(
  ADMIN_ACTIVE,
  async (id, blockReasonId, note, basedOn, callback) => {
    try {
      await api.User.block(id, blockReasonId, note, basedOn);
      callback && callback(true);
    } catch (error) {
      callback && callback(false);
    }
  }
);

export const unblockAdmin = createAction(ADMIN_INACTIVE, async (id) => {
  await api.User.unblock(id);
});

// Selectors
export const selectAll = state => state.admin.operator;

// Reducer
const initialState = {
  admins: [],
  page: 1,
  itemPerPage: 10,
  total: 0,
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload,
});

export default handleActions(
  {
    [ADMIN_GET]: updateState,
    [ADMIN_CHANGE_PAGE]: updateState,
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdminPage/admin.ducks.ts